'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../../core/utils');

var _utils2 = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresReservationTickets = function () {
    function WinresReservationTickets($scope, $timeout, $location, productService, localizationService, $document, $rootScope, discountService, $filter, userService, urlService) {
        _classCallCheck(this, WinresReservationTickets);

        this.endDateDisabled = false;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$location = $location;
        this.productService = productService;
        this.localizationService = localizationService;
        this.$scope.moment = moment;
        this.$document = $document;
        this.discountService = discountService;
        this.$filter = $filter;
        this.userService = userService;
        this.urlService = urlService;

        this.products = []; // List of available products returned by backend
        this.searchProduct = null; // Product chosen by user from above list, no Start/EndDate filled
        this.retrievedProduct = null; // Product returned by backend, Start/EndDate filled,
        // used for adding to cart
        this.allProducts = null; // Used for listing all products and then listing forced products from it
        this.forcedProducts = null;
        this.$scope.SelectedForcedProducts = [];
        this.totalPassengerAmount = null;

        this.allowChoosingEndDate = false;

        this.triedRefreshWhenNothingToAdd = 0;

        this.$rootScope.accommodationAddedToCart = false;

        this.terms = {
            destinationCode: null,
            productCode: null,
            startDate: null,
            endDate: null
        };

        this.open = {
            startDate: false,
            endDate: false
        };

        if (this.daterangeCalendar === "true") {
            this.daterangeDates = [];

            this.daterange = {
                startDate: null,
                endDate: null
            };
        }

        // If this is a package, it is loaded here.
        this.package = null;

        // If this is a package, its price is stored here.
        this.packagePrice = invalidPackagePrice('.');
    }

    _createClass(WinresReservationTickets, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (this.hideEndDate === 'true') {
                this.endDateDisabled = true;
            }

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().DestinationCode
            // getContext().Destination
            // getContext().DefaultStartDate
            // getContext().DefaultEndDate
            // getContext().DestinationCode
            // getContext().Products
            // getSeoState()
            // Params
            // findOrCreateProductLineByProduct()
            // findOrCreatePriceSelection()

            // Set:
            // getContext().DestinationCode
            // getContext().startDate
            // getContext().endDate
            // getContext().PriceGroup
            // getContext().Products

            // Other:
            // getOrCreateDummyPassengers()
            // addExtraServiceToPassenger()
            // findOrCreatePriceSelection()
            // getPassengersForPricing()

            if (!this.winresReservationContext) {
                if (window.definiteWinresReservationContext) {
                    console.log('[winres-reservation-tickets]', 'Context is not available. Falling back to global.');
                    this.winresReservationContext = window.definiteWinresReservationContext;
                } else {
                    throw new Error('A context is required.');
                }
            }

            var wrc = this.winresReservationContext;
            this.data = this.winresReservationContext.getContext();

            this.useSeo = this.winresReservationContext.getSeoState();

            // this is set to true when capacity is loaded for daterangecalendar
            this.showCalendar = false;

            this.isPackage = false;
            if (this.packageType !== undefined && this.packageType != "") {
                this.noPackage = false;
                this.$scope.$watch(function () {
                    return _this.data.Destination;
                }, function (destination) {
                    if (_this.data.Destination) {
                        if (_this.data.Destination.Type == _this.packageType) {
                            _this.isPackage = true;
                            _this.$scope.$watchGroup([function () {
                                return wrc.Params.DestinationCode;
                            }, function () {
                                return wrc.Params.StartDate;
                            }, function () {
                                return wrc.Params.EndDate;
                            }, function () {
                                return _this.terms.startDate;
                            }], function () {
                                _this.loadPackage(wrc.Params.DestinationCode, _this.terms.startDate, _this.terms.endDate);
                            });
                        }
                    }
                });
                this.$scope.$watchGroup(['$ctrl.isPackage', '$ctrl.package', '$ctrl.data.NumAdults', '$ctrl.data.NumChildren'], function () {
                    return _this.updatePackagePrice();
                });
            }

            this.today = new Date();

            if (this.daterangeCalendar === "true") {
                this.$scope.$watch(function () {
                    return _this.products;
                }, function (products) {
                    if (products[0] != null) {
                        if (products[0].DestinationInfo.ProductType != 'MÖ' && products[0].DestinationInfo.ProductType != 'HU' && products[0].DestinationInfo.ProductType != 'HY') {
                            _this.singleDatePicker = true;
                            _this.daterange.endDate = null;
                        }
                    }
                });
            }

            // The undefined case happened. I'm assuming it's supposed to behave the same as ''.
            if (this.departureCode !== '' && this.departureCode !== undefined) {
                this.data.DestinationCode = this.departureCode;
            }

            // this.$scope.$watch(() => this.data.DestinationCode, destinationCode => {
            //     if(destinationCode != null){
            //         this.terms.destinationCode = destinationCode;
            //         this.resetSearchProduct();
            //         this.fetchProducts(destinationCode, wrc.Params.ProductCode);
            //     }
            // });

            // Reset dates correctly on product change.
            this.$scope.$watch(function () {
                return wrc.getUrlParams().ProductCode;
            }, function () {
                _this.showCalendar = false;
            });

            this.$scope.$watchGroup(['$ctrl.data.Destination', '$ctrl.data.NumAdults', '$ctrl.data.NumChildren', '$ctrl.data.NumInfants'], function () {
                if (_this.data.Destination != null && _this.data.Destination.DestinationCode != null) {
                    _this.terms.destinationCode = _this.data.Destination.DestinationCode;
                    _this.terms.numAdults = _this.data.NumAdults;
                    _this.terms.numChildren = _this.data.NumChildren;
                    _this.terms.numInfants = _this.data.NumInfants;
                    _this.refreshCalendarDates();
                    // this.resetSearchProduct();
                    _this.fetchProducts(_this.data.Destination.DestinationCode, wrc.getUrlParams().ProductCode);
                }
            });

            this.$scope.$watch(function () {
                return _this.searchProduct;
            }, function (product) {
                _this.retrievedProduct = null;

                if (product !== null) {

                    _this.terms.productCode = product.DestinationInfo.ProductCode;
                    _this.allowChoosingEndDate = product.ForceReservedDays === null;
                    // With these product the vusual component endDate
                    // should be disabled but on working condition
                    // for the backend api call.
                    var productTypesToBeDisabled = ['MU', 'VV'];
                    _this.endDateDisabled = productTypesToBeDisabled.indexOf(product.DestinationInfo.ProductType) != -1 ? true : false;
                    // console.log(this.endDateDisabled);
                    _this.updateEndDateIfLengthIsForced(_this.terms.startDate);
                } else {
                    _this.terms.productCode = null;
                }
            });

            // Select first amount option when accommodation gets removed from shopping cart.
            this.$scope.$watchCollection('$ctrl.data.Products', function () {
                if (_this.retrievedProduct) {
                    var line = _this.winresReservationContext.findProductLineByProduct(_this.retrievedProduct, _this.retrievedProduct.DestinationInfo.Accommodation);

                    if (line === undefined) {
                        _this.selectFirstAmount();
                    }
                }
            });

            this.refreshCalendarDates();

            // Some products (extra services) have forced end date one day after
            // the start date. Update end date accordingly.
            this.$scope.$watch(function () {
                return _this.terms.startDate;
            }, function (startDate) {
                _this.updateEndDateIfLengthIsForced(startDate);
                _this.minEndDate = startDate;
            });

            this.isInitial = true;
            this.$scope.$watch(function () {
                return _this.terms;
            }, function (terms) {
                return _this.refresh(terms);
            }, true);

            if (this.daterangeCalendar === "true") {
                // Note: daterangepicker does on update this.daterange on if we don't change endDate (bug?)
                // The above makes no sense - is the first "on" an autocorrect typo of "not"?
                this.$scope.$watch(function () {
                    return _this.daterange;
                }, function (newDate) {
                    var element = angular.element('#reservation-title');
                    if (element && element.length === 1) {
                        // console.log("scrollToElement input is: ", element);
                        // scrollToElement is some Angular plugin, see package.json
                        _this.$document.scrollToElement(element, 100, 1000);
                    }

                    if (_this.daterange == null) {
                        throw new Error('[WinresReservationTickets] Dates are required.');
                    } else if (_this.daterange.startDate == null && _this.daterange.endDate == null) {
                        if (_.isFunction(_this.daterange.toDate)) {
                            // When does this case happen? The old code had it, but no explanation for it.
                            var date = _this.daterange.toDate();
                            _this.terms.startDate = date;
                            _this.terms.endDate = date;
                            _this.data.startDate = date;
                            _this.data.endDate = date;
                        } else {
                            throw new Error('[WinresReservationTickets] Dates are required.');
                        }
                    } else {
                        _this.terms.startDate = _this.daterange.startDate && _this.daterange.startDate.toDate();
                        _this.terms.endDate = _this.daterange.endDate && _this.daterange.endDate.toDate();
                        _this.data.startDate = _this.daterange.startDate && _this.daterange.startDate.toDate();
                        _this.data.endDate = _this.daterange.endDate && _this.daterange.endDate.toDate();
                    }

                    var params = _this.winresReservationContext.getUrlParams();

                    _this.urlService.setParamsToUrl({
                        dn: params.DestinationName,
                        dc: params.DestinationCode,
                        pc: params.ProductCode,
                        bd: moment(_this.terms.startDate).format('YYYY-MM-DD'),
                        ed: moment(_this.terms.endDate).format('YYYY-MM-DD'),
                        na: params.NumAdults,
                        nc: params.NumChildren,
                        ni: params.NumInfants
                    }, false);
                }, true);
            }

            this.$scope.accommodationInCart = false;
            // this.$scope.$watch(() => this.data.Products,
            //                    () => {
            //                         this.getIfAccommodationAdded();
            //                         //if(!this.contextDatesSet)
            //                         //    this.getStartAndEndDateFromContext();
            //                    }, true);

            // Watch discounted products in shopping cart.
            this.watchDiscountProducts();
        }
    }, {
        key: 'refreshCalendarDates',
        value: function refreshCalendarDates() {
            var urlParams = this.winresReservationContext.getUrlParams();

            var startDateString = urlParams.StartDate;
            var endDateString = urlParams.EndDate;

            // Fix invalid dates.
            this.data.DefaultStartDate = startDateString;
            this.data.DefaultEndDate = endDateString;

            if (startDateString) {
                //console.log('123', startDateString, this.data.DefaultStartDate);
                //var formatEndDateString = moment(endDateString).format("l");
                // ISO format is not supported by safari (YYYY-MM-DD) -> new Date(startDateString) may return null.
                var formatStartDateString = startDateString.replace(/-/g, "/"); // Format to YYYY/MM/DD.

                this.terms.startDate = new Date(formatStartDateString);
                // console.log("[WRT] this.terms.startDate = ", this.terms.startDate)
                if (this.daterangeCalendar === "true") {
                    this.daterange.startDate = moment(this.terms.startDate); // NaN bug if terms.startDate is null. 
                }
            } else if (this.data.DefaultStartDate) {
                this.terms.startDate = new Date(this.data.DefaultStartDate);
                if (this.daterangeCalendar === "true") {
                    this.daterange.startDate = moment(this.terms.startDate);
                }
            }
            // var endDateString = readUrlPart(this.$location, this.useSeo ? 3 : 2);
            if (endDateString) {
                var formatEndDateString = endDateString.replace(/-/g, "/"); // Format to YYYY/MM/DD.
                this.terms.endDate = new Date(formatEndDateString);
                if (this.daterangeCalendar === "true") {
                    this.daterange.endDate = moment(this.terms.endDate);
                }
            } else if (this.data.DefaultEndDate) {
                this.terms.endDate = new Date(this.data.DefaultEndDate);
                if (this.daterangeCalendar === "true") {
                    this.daterange.endDate = moment(this.terms.endDate);
                }
            }
        }
    }, {
        key: 'watchDiscountProducts',
        value: function watchDiscountProducts() {
            var _this2 = this;

            this.$scope.$watch(function () {
                return _this2.userService.getCurrentUser();
            }, function (user) {
                if (user) {
                    if (_this2.discountCodeWatch) {
                        // Cancel watch.
                        _this2.discountCodeWatch();
                    }

                    _this2.discountCodeWatch = _this2.$scope.$watch(function () {
                        return _this2.data.Products;
                    }, function () {
                        // Check discounted products in shopping cart.
                        _this2.checkDiscountCode();
                    }, true);
                }
            });
        }
    }, {
        key: 'checkDiscountCode',
        value: function checkDiscountCode() {
            var discountCode = this.discountService.getDiscountCodeFromLocalStorage();

            if (discountCode) {
                this.useDiscountCode(discountCode);
            }
        }
    }, {
        key: 'useDiscountCode',
        value: function useDiscountCode(discountCode) {
            var _this3 = this;

            var request = this.discountService.useDiscountCode(discountCode, this.data.Products, this.data.Passengers);

            request.then(function (discounts) {
                if (discounts == null) {
                    // Canceled.
                    return;
                }

                // Clear exising discount products.
                _this3.discountService.clearDiscountProductsFromCart(_this3.winresReservationContext);

                if (discounts.length > 0) {
                    _.each(discounts, function (d) {
                        _this3.discountService.addDiscountProductToCart(_this3.winresReservationContext, discountCode, d.Price, d.DestCode, d.ProdCode, d.BeginDate, d.EndDate, d.Name, d.Scope);
                    });
                    _this3.discountService.createDiscountProducts(_this3.winresReservationContext);
                    _this3.discountService.saveDiscountCodeToLocalStorage(discountCode);

                    // Prebook discount code.
                    _this3.data.DiscountCode = discountCode;
                }
            });
        }
    }, {
        key: 'getStartAndEndDateFromContext',
        value: function getStartAndEndDateFromContext() {
            var accommodations = _.filter(this.data.Products, function (product) {
                return product.Product.DestinationInfo.Accommodation;
            });
            if (accommodations && accommodations.length > 0) {
                this.daterange.startDate = moment(accommodations[0].Product.BeginDate);
                this.daterange.endDate = moment(accommodations[0].Product.EndDate);
            }
            this.contextDatesSet = true;
        }
    }, {
        key: 'refresh',
        value: function refresh(terms) {
            // Remember user-selected dates if the user navigates. This is
            // also used in the search criteria thing.
            if (!this.isInitial) {
                if (this.terms.startDate) {
                    // Store as ISO date string, since sessionStorage does
                    // not support storing Date objects.
                    this.data.DefaultStartDate = (0, _utils.formatISODate)(this.terms.startDate);
                }
                if (this.terms.endDate && (this.open.endDate || this.daterangeCalendar === 'true')) {
                    this.data.DefaultEndDate = (0, _utils.formatISODate)(this.terms.endDate);
                }
            }
            this.isInitial = false;

            if (terms.productCode === null) {
                // console.log('[WRT] No product chosen');
                return;
            }

            this.prices = [];
            this.priceNote = "";

            // Is this necessary?
            // if(!this.isReservableProduct(terms.startDate, terms.endDate)) {
            //     this.prices = [];
            //     this.priceNote = "";
            //     return;
            // }

            this.fetchPrices(terms);
            this.fetchAllProductsWithDates(terms);
            this.setTotalPassengerAmount();
        }
    }, {
        key: 'getAmountOptions',
        value: function getAmountOptions(index) {
            return _.range(this.getCapacityLeft() + 1);
        }
    }, {
        key: 'isTooManyChosen',
        value: function isTooManyChosen() {
            var chosen = _.sum(this.chosenAmounts, function (amount) {
                return amount;
            });
            return chosen === 0 || chosen > this.getCapacityLeft();
        }
    }, {
        key: 'getCapacityLeft',
        value: function getCapacityLeft() {
            if (this.retrievedProduct == null) {
                return 0;
            }

            var line = this.winresReservationContext.findProductLineByProduct(this.retrievedProduct, this.retrievedProduct.DestinationInfo.Accommodation);

            // Prevent accommodation with different period
            if (line !== undefined && this.retrievedProduct.DestinationInfo.Accommodation && (this.retrievedProduct.BeginDate !== line.Product.BeginDate || this.retrievedProduct.EndDate !== line.Product.EndDate)) {
                return 0;
            }

            var amount = line ? line.Amount : 0;
            return this.retrievedProduct.Capacity - amount;
        }
    }, {
        key: 'selectFirstAmount',
        value: function selectFirstAmount() {
            if (this.getCapacityLeft() > 0) {
                // Select one in amount select.
                this.chosenAmounts = [1];
            } else {
                this.chosenAmounts = [0];
            }
        }

        // isReservableProduct(beginDate, endDate) {
        //     var formattedBeginDate = moment(beginDate).format('YYYY-MM-DD');
        //     var formattedEndDate = moment(endDate).format('YYYY-MM-DD');

        //     let i = -1;
        //     for(let e of this.daterangeDates) {
        //         const prevDate = this.daterangeDates[i++];

        //         var date = new Date(e.Date);
        //         if(date >= beginDate && date < endDate) {
        //             // Non reservable dates between selection
        //             if (e.Capacity <= e.Sold
        //              && prevDate.Capacity <= prevDate.Sold) {
        //                 return false;
        //             } else if(formattedBeginDate === e.Date && (e.Forbidden === 1 || e.Forbidden === 3)) {
        //                 return false;
        //             } else if(formattedEndDate === e.Date && (e.Forbidden === 2 || e.Forbidden === 3)) {
        //                 return false;
        //             }
        //         }
        //     }
        //     return true;
        // }

    }, {
        key: 'updateCalendar',
        value: function updateCalendar() {
            var _this4 = this;

            this.productService.getCapacityCalendar(this.data.Destination.DestinationCode, this.products[0].DestinationInfo.ProductCode).then(function (capacity) {
                if (capacity) {
                    _this4.showCalendar = true;
                    _this4.daterangeDates = capacity; //

                    // No forbidden days to activities.
                    if (_this4.data.Destination.Type === 'OP') {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = capacity[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var e = _step.value;

                                e.Forbidden = 0;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                }
            });
        }
    }, {
        key: 'addToCart',
        value: function addToCart() {
            var _this5 = this;

            if (!this.hasSomethingToAdd()) {
                console.log('[WRT] Nothing to add to cart');
                return;
            }

            // Get forced extra services errors.
            var extraServiceErrors = this.winresReservationContext.getErrors('extraservice_groups');
            if (extraServiceErrors.length > 0) {
                this.winresReservationContext.showErrors('extraservice_groups');
                this.$rootScope.$broadcast('popup-error', extraServiceErrors);
                return;
            }

            console.log('[WRT] Adding to cart:', this.retrievedProduct);

            //console.log("this.retrievedProduct", this.retrievedProduct);
            var res = this.winresReservationContext;
            var line = res.findOrCreateProductLineByProduct(this.retrievedProduct);

            // Temporary check until multiple product support is implemented for Opera.
            if (this.allowBookingOnlyOne(this.retrievedProduct) && line.Amount > 0) {
                console.warn('[WRT] Can only book one of this product.');
                return;
            }

            // Add forced extra services to cart.
            this.$rootScope.$broadcast('add-forced-extra-services-to-cart');

            line.TotalPrice = line.TotalPrice || 0;
            line.UnitPrice = null;
            //console.log("line", line);
            var numPrices = 0;
            var passengerAssignments = [];

            for (var i = 0; i < this.prices.length; ++i) {
                var price = this.prices[i];
                var chosenAmount = this.chosenAmounts[i];
                if (chosenAmount > 0) {
                    numPrices++;
                    line.UnitPrice = price.Price;
                    if (this.useDummyPassengers(this.retrievedProduct)) {
                        ++line.Amount;
                        var productNumber = line.Amount;
                        console.log('[WRT] Selected product is an Opera, Sportum or HotelLinx product. Assigning dummy passengers.');
                        this.assignDummyPassengersToProductLine(line, productNumber);
                    } else if (line.Product.DestinationInfo.Accommodation === true) {
                        // Create passenger assignments.
                        res.addExtraServiceToPassenger(this.retrievedProduct, 0, chosenAmount, null, null);
                    }

                    if (price.Index !== null) {
                        var priceSelection = res.findOrCreatePriceSelection(price.Index, line);
                        priceSelection.Amount += chosenAmount;
                    }

                    line.TotalPrice += chosenAmount * price.Price;
                    line.TaxPercent = this.TaxPercent;
                }

                var capacityLeft = this.getCapacityLeft();
                if (this.chosenAmounts[i] > capacityLeft) {
                    this.chosenAmounts[i] = capacityLeft;
                }
            }

            if (numPrices > 1) {
                line.UnitPrice = null;
            }

            if (line.Product.DestinationInfo.Accommodation === false) {
                // Get product line amount by price selections.
                line.Amount = _.sumBy(line.PriceSelections, 'Amount');
            }

            //Add forced products
            /*_.each(this.$scope.SelectedForcedProducts, selectedForcedProduct => {
                if (selectedForcedProduct !== undefined) {
                    if (selectedForcedProduct) {
                      var di = selectedForcedProduct.Product.DestinationInfo;
                       console.log('[WRT] Adding forced product', di.DestinationCode, di.ProductCode, '-', selectedForcedProduct);
                       //console.log("[WRT] selectedForcedProduct:" + selectedForcedProduct.Product.DestinationInfo.ProductName + ": ", selectedForcedProduct);
                      var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(selectedForcedProduct.Product);
                      productLine.Amount = selectedForcedProduct.Amount;
                      productLine.UnitPrice = parseFloat(selectedForcedProduct.SelectedPrice.Price.toString().replace(',', '.'));
                      productLine.TotalPrice = parseFloat(selectedForcedProduct.Amount) * parseFloat(selectedForcedProduct.SelectedPrice.Price.toString().replace(',', '.'));
                      productLine.TaxPercent = parseFloat(selectedForcedProduct.Product.TaxPros.toString().replace(',', '.'));
                      //console.log("[WRT] selectedForcedProduct productLine: " + selectedForcedProduct.Product.DestinationInfo.ProductName + ": ", productLine);
                       if (di.ProductType == 'VV') {
                        console.log('[WRT] Selecting price for forced product',
                                    di.DestinationCode, di.ProductCode,
                                    '-',
                                    selectedForcedProduct.SelectedPrice);
                        var priceSelection = this.winresReservationContext.findOrCreatePriceSelection(selectedForcedProduct.SelectedPrice.Index, productLine);
                        //console.log("[WRT] selectedForcedProduct: priceselection for " + selectedForcedProduct.Product.DestinationInfo.ProductName + ": ", priceSelection);
                        // Setting amount instead of adding because forced products don't need to be added
                        priceSelection.Amount = selectedForcedProduct.Amount;
                        //console.log("[WRT] selectedForcedProduct: priceselection Amount for" + selectedForcedProduct.Product.DestinationInfo.ProductName + ": " +  priceSelection.Amount);
                      }
                      else {
                        if (selectedForcedProduct.Product.LinkingInfo.IsForEachPassenger) {
                            // Add for every passenger. _Amount_ is the same as number of passengers.
                            console.log('[WRT] Assigning forced product', di.DestinationCode, di.ProductCode,
                                        'for all passengers');
                            for (var i = 0; i < selectedForcedProduct.Amount; ++i) {
                            res.addExtraServiceToPassenger(selectedForcedProduct.Product, i,
                                                            1, null, null);
                            }
                        }
                        else {
                            // Add all instances of the product to the first passenger.
                            // (Presumably, _Amount_ is always 1 in this case.)
                            console.log('[WRT] Assigning forced product', di.DestinationCode, di.ProductCode,
                                        'for the first passenger. Amount:', selectedForcedProduct.Amount);
                            res.addExtraServiceToPassenger(selectedForcedProduct.Product, 0,
                                                        selectedForcedProduct.Amount, null, null);
                        }
                      }
                    }
                }
            });*/

            this.$scope.justAddedToCart = true;
            this.$timeout(function () {
                _this5.$scope.justAddedToCart = false;
            }, 5000);

            //console.log('calling onAdd');
            this.onAdd({ 'window': window });
            //console.log('after calling onAdd');

            // Google analytics.
            this.winresReservationContext.analyticsEvent("trackCart");
        }
    }, {
        key: 'assignDummyPassengersToProductLine',
        value: function assignDummyPassengersToProductLine(productLine, productNumber) {
            var passengerAmounts = {
                adults: this.data.NumAdults || 0,
                children: this.data.NumChildren || 0,
                infants: this.data.NumInfants || 0
            };
            // console.log('[WRT] Assigning dummy passengers. Amounts:', passengerAmounts);
            var eventDate = moment(productLine.Product.BeginDate);
            var res = this.winresReservationContext;

            // Clear duplicate passengers for Opera and Sportum products
            this.data.Passengers = [];

            var passengerIndexes = res.getOrCreateDummyPassengers(eventDate, passengerAmounts, this.data.ChildrenAges);
            productLine.PassengerAssignments = _.map(passengerIndexes, function (index) {
                return {
                    PassengerNumber: index,
                    ProductNumber: productNumber,
                    Comment: null,
                    Comment2: null
                };
            });
            //console.log('[WRT] Assigned', passengerIndexes.length, 'dummy passengers.');
            // console.log('[WRT] Product line:', productLine);
            // console.log('[WRT] All passengers:', this.data.Passengers);
        }
    }, {
        key: 'hasSomethingToAdd',
        value: function hasSomethingToAdd() {
            var hasSomethingToAdd = this.retrievedProduct !== null && _.some(this.chosenAmounts, function (amount) {
                return amount > 0;
            });
            if (!hasSomethingToAdd) {
                // Sometimes seldom the selection of this.retrievedProduct seems to fail and hasSomethingToAdd() fails
                // which result in customer not being able to just click on "add to cart" on preselected dates
                // customer tries to click and nothing happens
                // to solve this, we try to refresh again
                if (this.triedRefreshWhenNothingToAdd < 1) {
                    this.refresh(this.terms);
                    // Counter to avoid infinite loop when hasSomethingToAdd() returns false
                    this.triedRefreshWhenNothingToAdd += 1;
                    console.error("hasSomethingToAdd check fails. May be not  error, but no product seems to be selected");
                    console.error("hasSomethingToAdd check fails: this.retrievedProduct: ", this.retrievedProduct);
                    console.error("hasSomethingToAdd check fails: this.chosenAmounts: ", this.chosenAmounts);
                }
            }
            return this.retrievedProduct !== null && _.some(this.chosenAmounts, function (amount) {
                return amount > 0;
            });
        }
    }, {
        key: 'resetSearchProduct',
        value: function resetSearchProduct() {
            // console.log('[WRT] Resetting search product');
            this.searchProduct = null;
            this.retrievedProduct = null;
        }
    }, {
        key: 'updateEndDateIfLengthIsForced',
        value: function updateEndDateIfLengthIsForced(startDate) {
            if (startDate === null) return;
            if (this.searchProduct === null) return;
            var forceReservedDays = this.searchProduct.ForceReservedDays;
            if (forceReservedDays === null) {
                if (this.terms.endDate <= startDate) {
                    this.terms.endDate = addDays(1, startDate);
                }
                return;
            }
            // console.log('[WRT] Updating end date due to forced length:', forceReservedDays);
            this.terms.endDate = addDays(forceReservedDays, startDate);
        }
    }, {
        key: 'fetchProducts',
        value: function fetchProducts(destinationCode, productCode) {
            var _this6 = this;

            this.productService.getReservableProduct(destinationCode, productCode, this.localizationService.getLanguage(), 1, true).then(function (product) {
                _this6.products = [product];
                //("tuotteet", this.products);
                if (product) {
                    _this6.searchProduct = product;
                }
                if (_this6.daterangeCalendar === 'true') {
                    _this6.updateCalendar();
                }
            });
        }
    }, {
        key: 'fetchPrices',
        value: function fetchPrices(terms) {
            var _this7 = this;

            this.prices = null;
            this.notEnoughBeds = false;

            if (terms.destinationCode === null) {
                // console.log('[WRT] No destination given');
                return;
            }
            if (terms.productCode === null) {
                // console.log('[WRT] No product chosen');
                return;
            }
            if (terms.startDate === null) {
                // console.log('[WRT] No start date chosen');
                return;
            }
            if (terms.endDate === null) {
                // console.log('[WRT] No end date chosen');
                return;
            }

            var params = {
                DestinationCode: terms.destinationCode,
                ProductCode: terms.productCode,
                StartDate: (0, _utils.formatISODate)(terms.startDate),
                EndDate: (0, _utils.formatISODate)(terms.endDate),
                NumAdults: terms.numAdults,
                NumChildren: terms.numChildren,
                NumInfants: terms.numInfants,
                Flags: ["K1ExtraAllMatchedPrices"],
                MinCapacity: 1,
                DiscountCode: this.discountService.getDiscountCodeFromLocalStorage()
            };

            // console.log('[WRT] Fetching prices:', params.DestinationCode, params.ProductCode,
            //             params.StartDate, params.EndDate);

            var language = this.localizationService.getLanguage();

            this.loadingPromise = this.productService.getReservableProductOrReasonWhyNotReservable(params, language).then(function (result) {
                // Set prices to [] here to indicate that the search has been
                // completed, even if the product is not available.
                _this7.prices = [];
                _this7.priceNote = "";

                if (result.NotReservable) {
                    console.log('[WRT] Product is not reservable. Reason:', result.NotReservable.Reason);
                    console.log('[WRT] Full nonreservability info:', result.NotReservable);

                    // Reason contains the reason the product is not available.
                    // Depending on the reason, other fields like PriceNote or
                    // MinimumDate may be set.
                    //
                    // Currently possible reasons are:
                    // - PriceNotFound - No price
                    // - PriceMinLength - Length of reservation is too short (P1/2/3).
                    //                    MinimumDays is set to shortest allowed length.
                    // - PriceStartWeekday - Start day is not an allowed weekday (P3)
                    // - PriceEndWeekday - End day is not an allowed weekday (P3)
                    // - PriceUnspecified - Pricing failed for an unspecified reason.
                    //                      PriceNote may contain extra info.
                    // - CapacityNoCapacityObject - No capacity row in database
                    // - CapacityNoCapacity - Sold out
                    // - CapacityClosingDate - The closing date has come.
                    //                         MinimumDate is set to next available date.
                    // - CapacityUnspecified - Capacity check failed for an unspecified reason.
                    _this7.notReservable = result.NotReservable;
                    _this7.priceNote = result.NotReservable.PriceNote;

                    return;
                }

                if (!result.Product) {
                    console.error('[WRT] Product not set even though NotReservable is clear.');
                    return;
                }

                _this7.retrievedProduct = result.Product;

                _this7.updatePrices(_this7.retrievedProduct, terms);

                // Try add product to cart.
                _this7.tryAutoAddToCart();

                // Select first amount option.
                _this7.selectFirstAmount();

                // Data layer event after retrieving product.
                _this7.winresReservationContext.dataLayerEvent('onLoadProduct', result.Product);
            });
        }
    }, {
        key: 'tryAutoAddToCart',
        value: function tryAutoAddToCart() {
            var _this8 = this;

            // Add product to cart only if addToCart=1 is set in url.
            if (!(0, _utils.getParameter)('addToCart') || (0, _utils.getParameter)('addToCart') && (0, _utils.getParameter)('addToCart') !== '1') {
                return;
            }

            // I hate doing these tricks, but without $timeout forced extra services are not being added to cart.
            this.$timeout(function () {
                if (!_this8.data.Products || _this8.data.Products.length > 0) {
                    // Add products only in empty shopping cart.
                    return;
                }

                if (_this8.isPackage) {
                    _this8.addToShoppingCart(_this8.package);
                } else {
                    _this8.addToCart();
                }
            });
        }
    }, {
        key: 'fetchAllProductsWithDates',
        value: function fetchAllProductsWithDates(terms) {
            var _this9 = this;

            this.allProducts = null;
            var params = {
                DestinationCode: terms.destinationCode,
                StartDate: (0, _utils.formatISODate)(terms.startDate),
                EndDate: (0, _utils.formatISODate)(terms.endDate),
                NumAdults: terms.numAdults,
                NumChildren: terms.numChildren,
                NumInfants: terms.numInfants,
                Flags: ["K1ExtraAllMatchedPrices"],
                DiscountCode: this.discountService.getDiscountCodeFromLocalStorage()
            };

            this.getReservableProducts(params).then(function (products) {
                // console.log("[WRT] fetchAllProductsWithDates: Got products: ", products);
                _this9.allProducts = products;
                _this9.convertPricesToNumber(_this9.allProducts);
                _this9.forcedProducts = _this9.filterForcedProducts(_this9.allProducts);
            }, function (error) {
                console.error("[WRT] Error in fetchAllProductsWithDates:", error);
            });
        }
    }, {
        key: 'filterForcedProducts',
        value: function filterForcedProducts(products) {
            //console.log("filterForcedProducts().. input products: ", products);
            var forcedProducts = _.filter(products, function (p) {
                //console.log("filterForcedProducts().. checking product: " + p.DestinationInfo.ProductName + ": ", p);
                if (p.LinkingInfo && p.LinkingInfo.ForcingMode == "Forced") {
                    return p;
                }
            });
            // console.log("Filtered forced products:", forcedProducts);
            return forcedProducts;
        }
    }, {
        key: 'setTotalPassengerAmount',
        value: function setTotalPassengerAmount() {
            this.totalPassengerAmount = this.data.NumAdults + this.data.NumChildren + this.data.NumInfants;
            if (isNaN(this.totalPassengerAmount)) {
                console.error("totalPassengerAmount is Nan!");
            }
            console.log("[WRT] Total passenger amount set to:", this.totalPassengerAmount);
        }
    }, {
        key: 'convertPricesToNumber',
        value: function convertPricesToNumber(object) {
            for (var i in object) {
                // Replace comma separators so that javascript understands the numbers
                // and check if number
                if (!isNaN(parseFloat(object[i].Price.replace(/\./g, '').replace(',', '.')))) {
                    // Replace comma separators so that javascript understands the numbers
                    object[i].Price = object[i].Price.replace(/\./g, '').replace(',', '.');
                    // convert to number
                    object[i].Price = parseFloat(object[i].Price);
                }
            }
        }
    }, {
        key: 'updatePrices',
        value: function updatePrices(product) {
            // console.log('[WRT] Updating prices for product:',
            //             product.DestinationInfo.DestinationCode,
            //             product.DestinationInfo.ProductCode,
            //             product);

            var prices = product.ReservablePrices || [];

            if (prices[0].IsDiscount) {
                // As if price was discounted. Shown in template.
                prices[0].PriceAfterDiscount = prices[0].Price;

                // Discount product price
                prices[0].DiscountPrice = -(prices[0].Original - prices[0].Price);

                // Use original price because actual price should get reduced by discount product
                prices[0].Price = prices[0].Original;
            }

            var capacity = product.Capacity;

            // Temporary solution until multiple product support for Opera is implemented.
            if (this.allowBookingOnlyOne(product)) {
                capacity = Math.min(capacity, 1);
            }

            this.prices = prices;
            this.TaxPercent = product.TaxPros;
            this.availableAmounts = _.range(0, capacity + 1);
            this.chosenAmounts = _.fill(new Array(prices.length), 0);

            // Auto-select prices (the first price)
            if (prices.length > 0) {
                var beds = product.DestinationInfo.Beds || 0;
                var extraBeds = product.DestinationInfo.ExtraBeds || 0;
                var adults = this.data.NumAdults || 0;
                var children = this.data.NumChildren || 0;
                var adultExtraBedsAllowed = product.DestinationInfo.AdultExtraBedsAllowed;

                var numToSelect = 0;
                if (beds > 0) {
                    var rooms = this.selectEnoughRoomsForPassengers(beds, extraBeds, adults, children, adultExtraBedsAllowed);
                    // TODO: If the passengers cannot be accommodated (e.g. not
                    // enough adults or capacity), show the user an error message
                    // instead of setting capacity to 0.
                    numToSelect = rooms || 0;
                } else {
                    numToSelect = adults + children;
                }

                if (capacity < numToSelect) {
                    // Don't select any, as not to fool the user into thinking that he
                    // has selected the product for everyone.
                    this.chosenAmounts[0] = 0;

                    this.showNotEnoughBedsError();
                } else {
                    this.chosenAmounts[0] = numToSelect;
                }
            }
        }
    }, {
        key: 'showNotEnoughBedsError',
        value: function showNotEnoughBedsError() {
            // Show not enough beds error.
            this.notEnoughBeds = true;
            this.prices = null;
        }

        // Temporary solutions for Opera problems. Should be replaced with something
        // more permanent if they are still needed later.

    }, {
        key: 'useDummyPassengers',
        value: function useDummyPassengers(product) {
            return this.isOperaProduct(product) || this.isSportumProduct(product) || this.isHotelLinxProduct(product);
        }
    }, {
        key: 'allowBookingOnlyOne',
        value: function allowBookingOnlyOne(product) {
            return this.isOperaProduct(product);
        }
    }, {
        key: 'isOperaProduct',
        value: function isOperaProduct(product) {
            return product.DataSources && product.DataSources.Capacity === "Opera";
        }
    }, {
        key: 'isSportumProduct',
        value: function isSportumProduct(product) {
            return product.DataSources && product.DataSources.Capacity === "Sportum";
        }
    }, {
        key: 'isHotelLinxProduct',
        value: function isHotelLinxProduct(product) {
            return product.DataSources && product.DataSources.Capacity === "HotelLinx";
        }
    }, {
        key: 'selectEnoughRoomsForPassengers',
        value: function selectEnoughRoomsForPassengers(bedsInRoom, extraBedsInRoom, adults, children, adultExtraBedsAllowed) {
            var rooms = 0;

            while (adults > 0) {
                ++rooms;

                var freeBeds = bedsInRoom;
                var freeExtraBeds = extraBedsInRoom;

                // 1) Accommodate one adult in the room (a room must have one adult)
                --adults;
                --freeBeds;

                // 2) Accommodate as many children in extra beds as will fit
                var childrenInExtraBeds = Math.min(freeExtraBeds, children);
                children -= childrenInExtraBeds;
                freeExtraBeds -= childrenInExtraBeds;

                // 3) Accommodate as many children in regular beds as will fit
                var childrenInBeds = Math.min(freeBeds, children);
                children -= childrenInBeds;
                freeBeds -= childrenInBeds;

                // 4) Accommodate as many adults in regular beds as will fit.
                //    Note that this will only happen if all children have already
                //    been accommodated.
                var adultsInBeds = Math.min(freeBeds, adults);
                adults -= adultsInBeds;
                freeBeds -= adultsInBeds;

                // 5) If adults can be accommodated in extra beds, do it here.
                if (adultExtraBedsAllowed) {
                    var adultsInExtraBeds = Math.min(freeExtraBeds, adults);
                    adults -= adultsInExtraBeds;
                    freeExtraBeds -= adultsInExtraBeds;
                } else {
                    // Why was this logged as an error? This is a completely normal situation!
                    // console.error('[WRT] Adult extra beds not allowed');
                }
            }

            // If there were any children left over, this should fail. This can
            // happen when there too few adults to put one in each room required for
            // the children.
            if (children > 0) {
                console.warn('[WRT] Cannot accommodate all children in rooms with at least one adult.');
                return null;
            }

            //console.log('[WRT] Selected', rooms, 'rooms.');

            return rooms;
        }
    }, {
        key: 'getReservableProducts',
        value: function getReservableProducts(params) {
            var language = this.localizationService.getLanguage();
            params.MinCapacity = 1;
            return this.productService.getReservableProducts(params, language);
        }
    }, {
        key: 'getIfAccommodationAdded',
        value: function getIfAccommodationAdded() {
            var _this10 = this;

            var foundAccommodation = false;
            _.each(this.data.Products, function (product) {
                if (product.Product.DestinationInfo.ProductType == 'MÖ' || product.Product.DestinationInfo.ProductType == 'HU' || product.Product.DestinationInfo.ProductType == 'HY') {
                    foundAccommodation = true;
                }
            });
            if (foundAccommodation) {
                // If found accommodation and it was not there earlier do this:
                if (this.$scope.accommodationInCart == false) {
                    console.log("[WRT] Accommondation added to cart! Broadcasting event..");
                    this.$timeout(function () {
                        _this10.$rootScope.$broadcast('accommodationAddedToCart');

                        // set this variable so that reservation extra services knows when to disable adding of extra services to cart
                        _this10.$rootScope.accommodationAddedToCart = true;
                    }, 1);
                }
                this.$scope.accommodationInCart = true;
                return true;
            }
            this.$scope.accommodationInCart = false;
            return false;
        }

        /* ACCOMMODATION PACKAGE FUNCTIONS */

    }, {
        key: 'parseToInt',
        value: function parseToInt(string) {
            var int = parseInt(string);
            //console.log(int);
            return int;
        }
    }, {
        key: 'loadPackage',
        value: function loadPackage(destCode, startDate, endDate) {
            var _this11 = this;

            this.package = null;
            var language = this.localizationService.getLanguage();
            var query = this.productService.getAccommodationPackage(destCode, startDate, endDate, language);
            query.then(function (pack) {
                console.log('[WRT - Loaded package]', pack);
                if (pack == null) {
                    _this11.noPackage = true;
                } else {
                    _this11.noPackage = false;
                }
                _this11.picks = _this11.initialPicks(pack);
                _this11.package = pack;
            });
        }
    }, {
        key: 'updatePackagePrice',
        value: function updatePackagePrice() {
            if (!this.isPackage) {
                // Not a package. Just set it to whatever.
                this.packagePrice = invalidPackagePrice('(Not a package)');
            } else if (!this.package) {
                // Not yet loaded.
                this.packagePrice = invalidPackagePrice('(...)');
            } else {
                this.packagePrice = this.getPackagePrice();
            }

            console.log('[WRT] Package price updated:', this.packagePrice);
        }
    }, {
        key: 'addToShoppingCart',
        value: function addToShoppingCart(pack) {
            var _this12 = this;

            // The price group to use for the package root product.
            // The linked products' price groups come from the linkings.
            this.data.PriceGroup = 'NR';

            try {
                var packageIndex = this.findNextFreePackageIndex(this.data.Products);
                var rootProductLine = this.addRootProduct(packageIndex, pack.RootProduct);
                _.each(pack.ForcedProducts, function (product) {
                    console.log('[WRT - Process forced product]', product.DestinationInfo.DestinationCode, product.DestinationInfo.ProductCode, product.BeginDate, product.EndDate);
                    _this12.addForcedProduct(packageIndex, product);
                });
                _.each(pack.GroupForcedProducts, function (group) {
                    var pickedIndex = _this12.picks.groupForced[group.Key];
                    // console.log(pickedIndex);
                    var pickedProduct = group.Value[pickedIndex];
                    // var firstProduct = group.Value[0];
                    _this12.addForcedProduct(packageIndex, pickedProduct);
                });

                this.$scope.justAddedToCart = true;
                this.$timeout(function () {
                    _this12.$scope.justAddedToCart = false;
                }, 5000);
            } catch (e) {
                this.data.Products = [];
                alert(e);
            }

            //console.log('calling onAdd');
            this.onAdd({ 'window': window });
            //console.log('after calling onAdd');
        }
    }, {
        key: 'findNextFreePackageIndex',
        value: function findNextFreePackageIndex(shoppingCartProductLines) {
            // Package indexes start from 1.
            var indexes = _.map(shoppingCartProductLines, function (line) {
                return line.PackageRootIndex || 0;
            });
            var highestExisting = _.max(indexes) || 0;
            return highestExisting + 1;
        }
    }, {
        key: 'initialPicks',
        value: function initialPicks(pack) {
            return {
                groupForced: this.initialPicksForGroupForcedProducts(pack.GroupForcedProducts)
            };
        }

        // Create an object where the keys are group IDs and values are initial selections. Initial selection = first value that has capacity.
        // E.g. { '1': 0, '2': 0 }

    }, {
        key: 'initialPicksForGroupForcedProducts',
        value: function initialPicksForGroupForcedProducts(groups) {
            var picks = {};
            _.each(groups, function (group) {
                var id = 0;
                var firstProduct = group.Value[0];
                var groupID = firstProduct.LinkingInfo.GroupID;
                _.each(group.Value, function (value, index) {
                    if (value.Capacity != 0) {
                        id = index;
                        return false;
                    }
                });
                picks[groupID] = id;
            });
            // console.log(picks);
            return picks;
        }
    }, {
        key: 'addRootProduct',
        value: function addRootProduct(packageIndex, product) {
            console.log('[WRT - Add root product]', product);

            var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(product);
            productLine.Amount = 1;
            productLine.Product.Amount = productLine.Amount;
            productLine.PackageRootIndex = packageIndex;

            var price = this.priceIndex(this.data.NumAdults, this.data.NumChildren || 0);
            if (price === null) {
                throw 'Amount of passengers not supported by accommodation packages.';
            }
            this.setPriceAmount(productLine, price, 1);
            this.winresReservationContext.calculateTotalPrice(productLine);

            return productLine;
        }
    }, {
        key: 'getPackagePrice',
        value: function getPackagePrice() {
            if (!this.isPackage) {
                console.error('[WRT] packagePrice() called, but this isn\'t a package.');
                return invalidPackagePrice('(Not a package)');
            }

            if (!this.package) {
                console.warn('[WRT] packagePrice() called, no package loaded yet.');
                return invalidPackagePrice('(...)');
            }

            var index = this.priceIndex(this.data.NumAdults, this.data.NumChildren || 0);
            if (index === null) {
                return invalidPackagePrice('(Wrong number of passengers)');
            }

            var price = _.find(this.package.RootProduct.ReservablePrices, function (p) {
                return p.Index == index;
            });
            if (!price) {
                console.error('[WRT] Package has no price for valid amount of passengers. Expected index:', index);
                return invalidPackagePrice('(Price missing)');
            }

            return price;
        }
    }, {
        key: 'priceIndex',
        value: function priceIndex(adults, children) {
            if (adults < 1 || adults > 3) {
                console.error('[WRT] Accommodation packages only support 1-3 adults.');
                return null;
            }
            if (children < 0 || children > 3) {
                console.error('[WRT] Accommodation packages only support 0-3 children.');
                return null;
            }
            return 4 * (adults - 1) + children + 1;
        }
    }, {
        key: 'addForcedProduct',
        value: function addForcedProduct(packageIndex, product) {
            console.log('[WRT - Add forced product]', product);
            if (product.DestinationInfo.Accommodation) {
                this.addAccommodationProduct(packageIndex, product);
            } else {
                this.addExtraServiceProduct(packageIndex, product);
            }
        }
    }, {
        key: 'addAccommodationProduct',
        value: function addAccommodationProduct(packageIndex, product) {
            console.log('[WRT - Add accommodation product]', product);

            var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(product);
            productLine.Amount = 1;
            productLine.Product.Amount = productLine.Amount;
            productLine.PackageMemberIndex = packageIndex;
            productLine.PriceGroup = product.LinkingInfo.LinkedPriceGroup;
            productLine.PriceIncludedInPackage = true;
            productLine.UnitPrice = 0;
            productLine.TotalPrice = 0;
            this.assignAllPassengersToAccommodation(productLine);
            // Success not currently checked
        }
    }, {
        key: 'addExtraServiceProduct',
        value: function addExtraServiceProduct(packageIndex, product) {
            console.log('[WRT - Add extra service product]', product);

            var productLine = this.winresReservationContext.findOrCreateProductLineByProduct(product);
            productLine.PriceGroup = product.LinkingInfo.LinkedPriceGroup;
            productLine.PackageMemberIndex = packageIndex;
            productLine.PriceIncludedInPackage = true;
            productLine.UnitPrice = 0;
            productLine.TotalPrice = 0;

            this.addProductForAllPassengers(product);
        }
    }, {
        key: 'assignAllPassengersToAccommodation',
        value: function assignAllPassengersToAccommodation(productLine) {
            var passengerAmounts = {
                adults: this.data.NumAdults || 0,
                children: this.data.NumChildren || 0,
                infants: this.data.NumInfants || 0
            };
            var eventDate = moment(productLine.Product.BeginDate);
            var res = this.winresReservationContext;
            res.getOrCreateDummyPassengers(eventDate, passengerAmounts, this.data.ChildrenAges);

            console.log("[WRT] Passengers: ", this.data.Passengers);

            var info = productLine.Product.DestinationInfo;
            var count = this.data.Passengers.length;
            if (count > info.Beds + info.ExtraBeds) {
                console.error('[WAP - Assign all passengers accommodation] Not enough beds.', 'Accommodation', info.DestinationCode, '/', info.ProductCode, 'has', info.Beds, 'regular beds', 'and', info.ExtraBeds, 'extra beds.', 'There are', count, 'passengers.');
                throw 'Not enough beds.';
            }
            // Nothing complex needs to be done here. We always reserve only one room.
            // If we reserved more, we'd need to take care that all rooms have adults etc.
            var roomNumber = 1; // The only room
            productLine.PassengerAssignments = [];
            for (var i = 0; i < count; ++i) {
                var assignment = {
                    ProductNumber: roomNumber,
                    PassengerNumber: i
                };
                productLine.PassengerAssignments.push(assignment);
            }
        }
    }, {
        key: 'addProductForAllPassengers',
        value: function addProductForAllPassengers(product) {
            var _this13 = this;

            var passengers = this.winresReservationContext.getPassengersForPricing(product.BeginDate);
            var passengersWithoutInfants = _.filter(passengers, function (o) {
                return o.Gender !== "IN";
            });
            _.each(passengersWithoutInfants, function (passenger, index) {
                _this13.winresReservationContext.addExtraServiceToPassenger(product, index);
            });
        }
    }, {
        key: 'setPriceAmount',
        value: function setPriceAmount(productLine, index, amount) {
            if (!amount) {
                throw 'Invalid amount.';
            }

            var price = _.find(productLine.Product.ReservablePrices, function (p) {
                return p.Index == index;
            });
            if (!price) {
                console.error('[WRT] Product has no such price:', index, productLine);
                throw 'No such price.';
            }
            var info = productLine.Product.DestinationInfo;
            console.log('[WRT - Set price amount]', info.DestinationCode, info.ProductCode, index, price ? price.Label : '???', amount);

            var selection = this.winresReservationContext.findOrCreatePriceSelection(index, productLine);
            selection.Amount = amount;
        }
    }, {
        key: 'getPriceAmount',
        value: function getPriceAmount(price, amount) {
            return this.$filter('i18next')(price.Label) + ' ' + this.$filter('currency')(price.Price * amount, '€', 2);
        }
    }, {
        key: 'isAccommodation',
        value: function isAccommodation() {
            var productType = this.products[0].DestinationInfo.ProductType;
            return ['MÖ', 'HU', 'HY'].indexOf(productType) !== -1;
        }
    }, {
        key: 'getCapacityText',
        value: function getCapacityText() {
            var capacityLeft = this.getCapacityLeft();

            if (capacityLeft <= 5) {
                if (capacityLeft === 0) {
                    return this.$filter('i18next')('capacity.sold_out');
                }

                // Show "places left" -text if available is less than 5.
                return this.$filter('i18next')('capacity.places_left_type', {
                    amount: capacityLeft
                });
            } else {
                return '';
            }
        }
    }]);

    return WinresReservationTickets;
}();

WinresReservationTickets.$inject = ['$scope', '$timeout', '$location', 'productService', 'localizationService', '$document', '$rootScope', 'discountService', '$filter', 'userService', 'urlService'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils2.getWebcomponentsUrl)($attrs.templateUrl)) : 'reservation-tickets';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('reservation-tickets', require('./winresReservationTickets.html'));
}]);

_module3.default.component('winresReservationTickets', {
    templateUrl: getTemplate,
    controller: WinresReservationTickets,
    bindings: {
        // Scope has window. thus, window.$('.shopping-cart').show() works in on-add.
        onAdd: '&',

        // Show date range calendar. true/false
        daterangeCalendar: '@',

        // Not reservable text
        notReservableText: '@',

        // Override current destination code
        departureCode: '@',

        // Type code for when item should be treated as package (this.data.Destination.Type)
        packageType: '@',

        // Disable end date
        hideEndDate: '@',

        // Show "places left" -text below calendar. true/false. Disabled by default.
        showCapacityText: '@',

        // Show destination product select input. true/false
        showDestinationProductSelect: '@',

        // Show week number in reservation calendar. true/false. true by default.
        showWeekNumber: '@',

        // English days of week. Split by , Sunday is first day.
        daysOfWeekEn: '@',

        // Finnish days of week. Split by , Sunday is first day.
        daysOfWeekFi: '@',

        // Swedish days of week. Split by , Sunday is first day.
        daysOfWeekSv: '@'
    },
    require: {
        winresReservationContext: '?^^winresReservationContext'
    }
});

function addDays(days, date) {
    var next = new Date(date.getTime());
    next.setDate(next.getDate() + days);
    return next;
}

function invalidPackagePrice(label) {
    return { Index: 0, Label: label, Price: 0 };
}


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationTickets/winresReservationTickets.js
// module id = 431
// module chunks = 2